<!-- Component for displaying the settings modal -->
<template>
	<precoa-modal
		:open="modelValue"
		@update:open="(value) => emit('update:modelValue', value ?? false)"
		:modal-title="t('home.inflation.inflationAdjustment')"
		@submit="adjustSettings"
	>
		<FormKit
			type="group"
			v-model="settingsForm"
		>
			<div class="mt-8 flex gap-4">
				<FormKit
					name="inflationRate"
					:label="t('home.inflation.inflationRate')"
					type="number"
					number="float"
					:step="0.25"
				/>
				<FormKit
					name="yearIncrements"
					:label="t('home.inflation.yearIncrements')"
					type="number"
					number="integer"
					:step="1"
				/>
			</div>
		</FormKit>
		<button
			type="submit"
			class="bg-accent-400 text-accent-700 disabled:bg-secondary-300 mt-8 w-full rounded-lg p-3 text-center font-bold"
		>
			{{ t('home.inflation.adjust') }}
		</button>
	</precoa-modal>
</template>

<script setup lang="ts">
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import { useUserSettingsStore } from '@/stores/settings'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
	modelValue: boolean
}>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
}>()

const settingsStore = useUserSettingsStore()

/** Store the settings
 * If the inflationRate or yearIncrements are already defined show those, otherwise undefined
 */
const settingsForm = ref({
	inflationRate: settingsStore.values.inflationRate ?? undefined,
	yearIncrements: settingsStore.values.inflationYearIncrements ?? undefined,
})

// Update the settings based on user input and close the modal
function adjustSettings() {
	const { inflationRate, yearIncrements } = settingsForm.value

	settingsStore.values = {
		...settingsStore.values,
		inflationRate,
		inflationYearIncrements: yearIncrements,
	}

	emit('update:modelValue', false)
}
</script>
